import { connect } from 'react-redux'
import AnnouncementsPage from '../components/AnnouncementsPage'
import {
  onFetchAnnouncements,
  onAnnouncementRead,
  sendAnnouncementsSeen
} from '../modules/Announcements'
import {
  onFetchInstrumentsByArchitecture,
  sendEvent
} from '../../Activities/modules/Instruments'
import { isBlockConsent } from '../../Consent/utils/consentUtils'

const mapStateToProps = (state) => {
  const { announcements, consent, loading, strings, user, instruments } = state

  const showConsentModal = isBlockConsent(user, consent)

  const announcementInstances = instruments?.instancesList?.filter(
    (instance) => instance?.instrument_type === 'ANNOUNCEMENT'
  ) ?? []
  const formattedAnnouncementsInstances = announcementInstances
    .map((instance) => ({
      id: instance?.instances?.[0]?.instance_id,
      title: instance?.instrument_title,
      instrument_type: instance?.instrument_type,
      instrumentID: instance.instrument_id,
      visible_days: instance?.visible_days,
      ...instance?.instances?.[0],
      content: instance?.metadata?.announcement_content?.content
    }))
  formattedAnnouncementsInstances.sort((a, b) =>
    a.start_date > b.start_date ? 1 : b.start_date > a.start_date ? -1 : 0,
  )

  return {
    announcements: announcements?.announcementsList ?? [],
    announcementsInstances: formattedAnnouncementsInstances ?? [],
    unreadAnnouncements: announcements?.unread ?? [],
    loading: loading?.general,
    onboarding: user?.onboarding?.announcements,
    strings,
    humiIsabellaDisabled:
      user?.study?.config?.is_rewardless_study &&
      user?.study?.config?.is_avatarless_study,
    showConsentModal
  }
}

const mapDispatchToProps = {
  fetchAnnouncements: () => onFetchAnnouncements(),
  fetchInstruments: () => onFetchInstrumentsByArchitecture(),
  onAnnouncementRead: (id) => onAnnouncementRead(id),
  sendEvent: (id, eventType) => sendEvent(id, eventType, null, true),
  onAnnouncementRead: (id, instrumentID) =>
    onAnnouncementRead(id, instrumentID),
  sendAnnouncementsSeen: (announcements) =>
    sendAnnouncementsSeen(announcements)
}

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementsPage)
